// extracted by mini-css-extract-plugin
export default {"project_container":"Projects_project_container__Y0xCW","title_container":"Projects_title_container__lyDN4"};